export const seasonalCourtPurchaseStatus = {
  Undefined: '0'
};


export const mappedSeasonalCourtPurchaseStatus = Object.entries(seasonalCourtPurchaseStatus)
  .map(([key]) => ({ value: key, label: key }));